import {ActivityI18n} from '@/locales/base.message.locales';

export const activities: ActivityI18n = {
  challenge: {
    abort: 'Você saiu do desafio: {title}',
    accept: 'Você aceitou o desafio: {title}'
  },
  forum: {
    create: 'Você criou um tópico chamado: {topic}, no desafio: {challenge_title}',
    delete: 'Você removeu o tópico: {topic}, do desafio: {challenge_title}'
  },
  task: {
    abort: 'Você deixou a tarefa: {name}, do desafio: {challenge_title}',
    join: 'Você aceitou a tarefa: {name}, do desafio: {challenge_title}'
  },
  team: {
    accepted: 'Você foi aceito no time: {name}, do desafio: {challenge_title}',
    create: 'Você criou o time: {name}, no desafio: {challenge_title}',
    delete: 'Você removeu o time: {name}, do desafio: {challenge_title}',
    request: 'Você solicitou para entrar no time: {name}, do desafio: {challenge_title} '
  },
  user: {
    register: 'Você se registrou'
  }
};
